import Model from './Model';
import Activity from './Activity';
import Address from './Address';
import Note from './Note';
import Order from './Order';

import axios from 'axios';

export default class Customer extends Model {
    resource () {
        return 'customers';
    }

    get mutations() {
        return {
            activity: Activity,
            addresses: Address,
            orders: Order,
            notes: Note,
        };
    }

    activity () {
        return this.hasMany(Activity);
    }

    addresses () {
        return this.hasMany(Address);
    }

    notes () {
        return this.hasMany(Note);
    }

    orders () {
        return this.hasMany(Order);
    }

    ban () {
        return axios.post('/customers/' + this.id + '/ban');
    }

    unban () {
        return axios.delete('/customers/' + this.id + '/ban');
    }

    addNote (contents) {
        let note = new Note({'contents': contents}).for(this);

        return note.save();
    }
}
